 
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import React, { useContext, useEffect, useState } from "react";

export default function MarkerPopupNormal({ item }) {
{/*🚗  🚙  🚘  🚖 🚕 🚔  🚓  🚐  🛻      */}
    return (
        <div className="popupMarker"  >
            {!item.validLastLocation &&
                <div className='row mt-3'>
                    <div className='col'>
                       ⚠️             
                        <div className='mt-1'>
                            <div>عدم آنتن دهی Gps</div>                          
                        </div>
                    </div>
                </div>
            }
            <div className="row mt-3 "   >
                <div className="col  " >
                   🚗 {`نام دستگاه : ${item.deviceName}`}
                </div>
            </div>
            <div className="row mt-3 "   >
                <div className="col  " > 
                     📅 تاریخ : <span className='fw-bold'>{item.dtFa} </span>
                </div>
            </div>
            <div className="row mt-3 "   >
                <div className="col  " > 
                     🕒 ساعت : <span className='fw-bold'>{item.time}</span>
                </div>
            </div>
            <div className="row mt-3 "   >
                <div className="col  " > 
                    🔑 وضعیت سوییچ : <span className='fw-bold'>{item.switch == 1 || item.shock == 1 ? "روشن" : "خاموش"}</span>
                </div>
            </div>

            <div className="row mt-3 "   >
                <div className="col  " >
                    💨 سرعت :<span className='fw-bold'>{(item.speed == 0 ? "ساکن" : item.speed)}</span> 
                </div>
            </div>
            <div className="row mt-3 "   >
                <div className="col  " > 
                    🔋 باتری : <span className='fw-bold'>{item.battery}</span>
                </div>
            </div>
            {'temp' in item && item.temp != null &&
                <div className="row mt-3 "   >
                    <div className="col  " > 
                        🌡️ دما : <span className='fw-bold'>{item.temp}`</span>
                    </div>
                </div>
            }
            {'chargeSimCard' in item && item.chargeSimCard != null && item.chargeSimCard > 0 &&
                <div className="row mt-3 "   >
                    <div className="col  " >
                        {item.chargeSimCard > 10000 ? "📶" : "🔴"}  شارژ سیم کارت : {item.chargeSimCard.toLocaleString()}ریال
                    </div>
                </div>
            }

            {'pelak' in item && item.pelak != null &&
                <div className="row mt-3 "   >
                    <div className="col  " >
                        🚗 پلاک : {item.pelak}
                    </div>
                </div>
            }
            {'nationalcode' in item && item.nationalcode != null &&
                <div className="row mt-3 "   >
                    <div className="col  " >
                       💳 کد ملی راننده :{item.nationalcode}
                    </div>
                </div>
            }
            {'mobile' in item && item.mobile != null &&
                <div className="row mt-3 "   >
                    <div className="col  " >
                        📞تلفن راننده : <span className='fw-bold'>{item.mobile}</span>
                    </div>
                </div>
            }
        </div>

    )
}